import React, { useEffect, useMemo } from 'react';

const CONFETTI_COLORS = ['#3B5BDB', '#22C55E', '#F59E0B', '#EF4444', '#8B5CF6'];

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 13l4 4L19 7"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FeedbackSuccess = ({ showConfetti = true }) => {
  const confettiPieces = useMemo(
    () =>
      Array.from({ length: 40 }, (_, i) => ({
        id: i,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 0.8}s`,
        color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
        rotation: `${Math.random() * 360}deg`,
      })),
    []
  );

  useEffect(() => {
    if (!showConfetti) return undefined;
    const timer = setTimeout(() => {
      const container = document.querySelector('.ef-confetti');
      if (container) container.style.display = 'none';
    }, 3000);
    return () => clearTimeout(timer);
  }, [showConfetti]);

  return (
    <>
      {showConfetti && (
        <div className="ef-confetti" aria-hidden="true">
          {confettiPieces.map((piece) => (
            <span
              key={piece.id}
              className="ef-confetti__piece"
              style={{
                left: piece.left,
                backgroundColor: piece.color,
                animationDelay: piece.delay,
                transform: `rotate(${piece.rotation})`,
              }}
            />
          ))}
        </div>
      )}
      <div className="ef-success">
        <div className="ef-success__icon">
          <CheckIcon />
        </div>
        <h2 className="ef-success__title">Thank you for your feedback!</h2>
        <p className="ef-success__subtitle">Your response has been recorded.</p>
      </div>
    </>
  );
};

export default FeedbackSuccess;
